/* @ngInject */
const myRailwaySelectCard = (
  utils,
  $$wagon,
  valueHandler,
  $$railway,
  toaster
) => {
  return {
    restrict: 'E',
    scope: {
      myRailway: '=',
      isChoose: '=',
    },
    template: require('./myRailwaySelectCard.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$railway.metadata.fields
      $scope.isChoose = false
      $scope.myRailway = null

      $scope.chooseRailway = (_railway, _selected) => {
        if (_selected) {
          $scope.isChoose = false
        } else {
          $scope.myRailway = _railway
          $scope.isChoose = true
        }
      }

      $scope.$watch('myRailway.id', async (value) => {
        if (valueHandler.isId(value)) {
          try {
            const data = {
              railwayId: value,
            }
            const response = await $$wagon.request.getBySearch(data)
            $scope.myRailway.wagons = response.wagons
          } catch (error) {
            toaster.error(error)
          }
        }
      })
    },
    link: {
      pre: async (scope, element, attrs) => {

        try {
          scope.railways = await $$railway.request.getByArea(1)
          if (scope.myRailway) {
            scope.myRailway = utils.getElementById(scope.railways, scope.myRailway.id)
          }
        } catch (error) {
          toaster.error(error)
        }
      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myRailwaySelectCard



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/inputs/myRailwaySelectCard.js